module.exports = __webpack_public_path__ + "static/media/moon.905eaed9.svg";